var initializeBlockHero = function(block){
    
    var video = jQuery('video', block);
    
    video[0].addEventListener('loadeddata', function() {
       video.addClass('loaded');
    }, false);
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-hero').each(function(){
        initializeBlockHero(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=hero', initializeBlockHero);
